import { Component, OnInit, Input, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
// import { async } from '@angular/core/testing';
//import {DOCUMENT} from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-oem-client-list',
  templateUrl: './oem-client-list.component.html',
  styleUrls: ['./oem-client-list.component.scss']
})
export class OEMClientListComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + 'uploads/';
  public deleteUserUrl = BaseUrlConstantsService.DELETE_USERS;
  public clientListingUrl = BaseUrlConstantsService.CLIENTS_LISTING;
  public assetsCountListUrl= BaseUrlConstantsService.Assets_Count;
  public subAssetsCountListUrl=BaseUrlConstantsService.Sub_Assets_Count;
  public OEM_Api = BaseUrlConstantsService.OEM_Client_List;
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public checked = false;
  public clientList: any;
  public showSentMessage: boolean;
  public selectValueArr: any = [];
  public allClients: any = [];
  public showEmptyError: any = '';
  public classAdd: any;
  public today: Date;
  public selectedClientIDsArr: any = [];
  public clientIdList : any =[];
  public allAssets : any;
  public mergeAp :any=[];
  public assetscolor :any[];
  public totalAssets: any;
  public clientIdListObj :any=[];
  public breadcrumbsArray: any = [
    'clients'
  ];
  public directionLogoHealthy:any="down";
  public directionLogoUnsatisfactory:any="leftright";
  public directionLogoUnacceptable:any="up";
  public DSP=BaseUrlConstantsService.DSP_KEY;
  public onlyForDsp=this.DSP;
  @Input() src: string;
  @Input() default: string;
  assetsCounterSt: boolean;
  countryName: any;
  public userId: any;

  constructor(
    private spinner: NgxSpinnerService,
    private changeService: ChangeUsersService,
    public router: Router,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    // @Inject(Document)private documented: Document
    ) {
      this.userId= localStorage.getItem('user_id');
    this.showSentMessage = true;
    this.utcTime();
  }
  updateUrl(val: any) {
  }

  utcTime() {

    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }


  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '150px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteUser(id, index);
      }
    });
  }

  seeUserAssets(userId, userName,vals) {
       const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        assetsFilterName: vals,
        admin_client_id: userId,
        clientName: userName,
        pageRef: 'OEMClientPage'
      }
    };
    this.router.navigate(['/device-report-new'], navigationExtras);
  }


  deleteUser(user_id, index) {
    this.service.deleteInfo(this.deleteUserUrl + "/" + user_id).then(res => {
      if (JSON.parse(JSON.stringify(res)).message.includes("successfully deleted")) {
        this.classAdd = index;
        this.service.showSuccess('Successfully deleted.');
        this.allClients.splice(index, 1);
        if (this.allClients.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }


  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async selectListItem(event: any, index: number, id: number) {
    if (event.checked) {
      this.selectValueArr.push(id);
    } else {
      this.selectValueArr.splice(index, 1);
    }
    this.selectedClientIDsArr = Array.from(new Set(this.selectValueArr));
  }

  trackByFn(index, item) {
    return item.id;
  }



  ngOnInit() {
    this.getAllClients(this.onlyForDsp);
  }


  sentMessage(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'viewSentmsg',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  viewAssetList(val:any,id,name){
    console.log(val,id,name, 'info')
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        clientName:name,
        assetsFilterName: val,
        admin_client_id:id,
        pid: true,
        pageRef: 'OEMClientPage'
      }
    };
    this.router.navigate(['/device-report-new'],navigationExtras);
  }

  // getAllClients() {

  //   this.service.getData(this.clientListingUrl + "CLIENT").then(async (res) => {
  //     console.log("1")
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
  //       console.log("2")
  //       this.clientList = JSON.parse(JSON.stringify(res)).data.body;
  //       console.log("3")
  //       //this.clientIdListObj=
  //       if (this.clientList.length !== 0) {
  //         this.showList = true;
  //         this.emptyMsg = false;
  //         this.changeService.loader(false);
  //         this.allClients= await this.clientList;
  //         console.log(this.allClients);
  //         this.clientIdList = this.allClients.map(ids => ids.id);
  //         this.clientIdListObj= {
  //           userIds:this.clientIdList
  //         }


  //         this.service.postData(this.assetsCountListUrl, this.clientIdListObj).then(async(res)=>{
  //           if (JSON.parse(JSON.stringify(res)).data.status === 'success'){

  //             this.allAssets=JSON.parse(JSON.stringify(res)).data.body;
  //             this.allAssets.clientsData.forEach(element => {
  //               var elementName = document.getElementById(element.userId)
  //               elementName.innerHTML = '<span dataText="Offline" type="button" routrLink="/device-report-new" id="span1" style="background:'+this.allAssets.healthStatusCode.OFFLINE+'">'+element.offlineAssetCount+'</span><img src="../../assets/arrow-'+element.avg_offline_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Healthy" style="background:'+this.allAssets.healthStatusCode.HEALTHY+'">'+element.healthyAssetCount+'</span><img src="../../assets/arrow-'+element.avg_healthy_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Unsatisfactory" style="background:'+this.allAssets.healthStatusCode.UNACCEPTABLE+'">'+element.unhealthyAssetCount+'</span><img src="../../assets/arrow-'+element.avg_unhealthy_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px"><span dataText="Unacceptable" style="background:'+this.allAssets.healthStatusCode.ERROR+'">'+element.errorAssetCount+'</span><img src="../../assets/arrow-'+element.avg_error_status+'-solid1.png" width="30px" height="30px" style="margin-top:3px">';
  //             });
  //             document.getElementById("span1").addEventListener('click',function(){
  //                 window.location.href='device-reports-component.html';
  //             });
  //             this.assetscolor=JSON.parse(JSON.stringify(res)).data.body.healthStatusCode;
  //           }
  //         });
  //       } else {
  //         this.showList = false;
  //         this.emptyMsg = true;
  //       }
  //     } else {
  //       this.changeService.loader(false);
  //       this.showList = false;
  //       this.emptyMsg = true;
  //       this.service.showError('Something went wrong.');
  //     }
  //   }, err => {
  //     this.changeService.loader(false);
  //   });
  // }

  //merge to api
  getAllClients(e) {
    if(e.checked==false && this.DSP)
      this.onlyForDsp=false;
   if(e.checked || this.onlyForDsp){
      this.spinner.show();
      this.service.getData(this.OEM_Api + "/" + this.userId).then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientList = JSON.parse(JSON.stringify(res)).data.body;
        //this.clientIdListObj=
        if (this.clientList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
          this.changeService.loader(false);
          this.allClients= await this.clientList;
          this.clientIdList = this.allClients.map(ids => ids.id);
          console.log(typeof this.clientIdList[0])
         this.clientIdList =this.clientIdList.map((index , key)=>{
           return parseInt(Math.floor(Math.random() * 90 + 10)+index.toString()+ Math.floor(Math.random() * 9000 + 1000));
          })
          this.clientIdListObj= {
            userIds:this.clientIdList
          }

          // console.log(  this.clientIdListObj,'dsfsfs')
          this.service.postData(this.subAssetsCountListUrl, this.clientIdListObj).then(async(res)=>{
            this.spinner.hide();
            console.log(res,'ressssssss');
            if(JSON.parse(JSON.stringify(res)).data.code.length==500){
              console.log('enerterinss')
              this.mergeAp=this.clientList;
              this.assetsCounterSt=false;
              this.spinner.hide();
            }
            else{
              this.assetsCounterSt=true;
              this.allAssets=JSON.parse(JSON.stringify(res)).data.body;
              this.mergeAp=this.allClients.map((obj, index)=>({
                 ...obj,
                 ...this.allAssets[index]
              }));
              console.log(this.mergeAp,'mergeApppppp')
              this.assetscolor=JSON.parse(JSON.stringify(res)).data.healthStatusCode;
              console.log(this.assetscolor,'color')
              this.spinner.hide();
            }
          // }, (err) => {
          //   console.log(err,'reerrr')
          //   this.spinner.hide();
          //   this.changeService.loader(false);
          });
        } else {
          this.showList = false;
          this.emptyMsg = true;
          this.spinner.hide();
        }
      } else {
        this.changeService.loader(false);
        this.showList = false;
        this.emptyMsg = true;
        this.spinner.hide();
        this.service.showError('Something went wrong.');
      }
     }, err => {
      this.changeService.loader(false);
      });
    }
    else{
      this.spinner.show();
      this.service.getData(this.OEM_Api + "/" + this.userId).then(async (res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.clientList = JSON.parse(JSON.stringify(res)).data.body;
          //this.clientIdListObj=
          if (this.clientList.length !== 0) {
            this.showList = true;
            this.emptyMsg = false;
            this.changeService.loader(false);
            this.allClients= await this.clientList;
            this.clientIdList = this.allClients.map(ids => ids.id);
            this.clientIdListObj= {
              userIds:this.clientIdList
            }


            this.service.postData(this.assetsCountListUrl, this.clientIdListObj).then(async(res)=>{
              if(JSON.parse(JSON.stringify(res)).code=="ER_NO_SUCH_TABLE"){
                this.mergeAp=this.clientList;
                this.assetsCounterSt=false;
              }
              else{
                this.assetsCounterSt=true;
                this.allAssets=JSON.parse(JSON.stringify(res)).data.body.clientsData;
                this.mergeAp=this.allClients.map((obj, index)=>({
                   ...obj,
                   ...this.allAssets[index]
                }));
                this.assetscolor=JSON.parse(JSON.stringify(res)).data.body.healthStatusCode;
                this.spinner.hide();
              }
            });
          } else {
            this.showList = false;
            this.emptyMsg = true;
            this.spinner.hide();
          }
        } else {
          this.changeService.loader(false);
          this.showList = false;
          this.emptyMsg = true;
          this.spinner.hide();
          this.service.showError('Something went wrong.');
        }
      }, err => {
        this.changeService.loader(false);
        });
    }
  }

//for mergeAp serchData
  searchData(ev) {
    if(this.allAssets!=undefined){
      this.allClients=this.clientList.map((obj,index)=>({
        ...obj,
        ...this.allAssets[index],
      }));
      const term = ev.toLowerCase();

      this.mergeAp = this.allClients.filter(tag => tag.company_name.toLowerCase().indexOf(term) >= 0 || tag.country.toLowerCase().indexOf(term) >= 0 || tag.industry_type.toLowerCase().indexOf(term) >= 0);
    }
  else{
    const term = ev.toLowerCase();
    this.mergeAp = this.allClients.filter(tag => tag.company_name.toLowerCase().indexOf(term) >= 0 || tag.country.toLowerCase().indexOf(term) >= 0 || tag.industry_type.toLowerCase().indexOf(term) >= 0);
  }
}

  async addClients() {
    this.router.navigate(['/add-client']);
  }

  async editClient(id) {
    this.countryName=this.mergeAp.filter(tag =>
      tag.id==id
  )
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        adminClientId: id,
        pid: true,
        countryname:this.countryName[0].country,
        pageRef: 'admin-client',

      }
    };
    this.router.navigate(['/add-client'], navigationExtras);
  }


  async showLicense() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'adminLicense'
      }
    });
  }
}
